import React from 'react';
export function Hero() {
  return <div className="w-full py-10 md:py-16" data-id="element-206">
      <div className="max-w-3xl mx-auto text-center mb-8" data-id="element-207">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight" data-id="element-208">
          You're Not Broken. There's a Silent Lock in Your Nervous System That's
          Keeping You <span className="text-purple-700" data-id="element-209">Emotionally Numb</span>.
        </h1>
        <h2 className="text-2xl md:text-3xl text-gray-700 mb-10 leading-relaxed" data-id="element-210">
          Discover the breakthrough Expressive Rewiring protocol that gently
          unlocks the frozen parts of your nervous system to allow you to feel
          again.
        </h2>
        <div className="w-full my-8" data-id="element-211">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/mPVsDQJ8Dr1Tkm5utfGqbD/Mockups_%2816%29.png" alt="Expressive Rewiring protocol illustration" className="w-full max-w-2xl mx-auto h-auto object-contain rounded-lg shadow-md" data-id="element-212" />
        </div>
        <div className="text-left mt-10" data-id="element-213">
          <p className="text-xl text-gray-700 mb-5" data-id="element-214">It starts slowly.</p>
          <p className="text-xl text-gray-700 mb-5" data-id="element-215">
            You don't notice at first.
          </p>
          <p className="text-xl text-gray-700 mb-5" data-id="element-216">
            One day, something wonderful happens—a beautiful moment, good news,
            laughter with someone you love—and instead of feeling joy…
          </p>
          <p className="text-xl text-gray-700 mb-5" data-id="element-217">…you feel nothing.</p>
          <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-5 text-center" data-id="element-218">
            Not sadness, not anger, not panic. Just an unsettling, empty
            nothingness.
          </h2>
          <p className="text-xl text-gray-700 mb-5" data-id="element-219">
            Maybe you've tried everything. Therapy, journaling, meditation,
            breathing exercises, affirmations, even medication.
          </p>
          <p className="text-xl text-gray-700 mb-5" data-id="element-220">
            But you're still waiting for the moment when life will feel real
            again.
          </p>
          <p className="text-xl text-gray-700 mb-5" data-id="element-221">
            And the longer it takes, the more quietly terrified you become:
          </p>
          <p className="text-xl text-gray-700 mb-5 italic" data-id="element-222">
            Is this just how I am now? Am I always going to feel half-alive?
            Will I ever reconnect with the parts of me that went quiet?
          </p>
          <p className="text-xl text-gray-700 mb-5 font-bold" data-id="element-223">
            If you've asked yourself those questions—especially when nothing
            else seems to help—there's a reason your body and emotions went
            quiet.
          </p>
          <p className="text-xl text-gray-700 mb-5" data-id="element-224">
            And it's not what you've been told.
          </p>
          <p className="text-xl text-gray-700 mb-5" data-id="element-225">
            In fact, what you're experiencing right now isn't even the real
            problem.
          </p>
          <p className="text-xl text-gray-700 mb-5" data-id="element-226">
            It's your body's intelligent response to something deeper—and until
            you understand exactly what that "something" is, no amount of
            pushing or forcing yourself will work.
          </p>
          <p className="text-xl text-gray-700 mb-5" data-id="element-227">
            But once you see it, everything shifts.
          </p>
        </div>
      </div>
    </div>;
}